import { render } from "./AddFormModal.vue?vue&type=template&id=081caef4&ts=true"
import script from "./AddFormModal.vue?vue&type=script&lang=ts"
export * from "./AddFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__